'use client';

import { useEffect, useState } from 'react';
import Modal from './Modal';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

export default function UnsubscribeModal() {
  const u = useTranslations('UnsubscribeModal');
  const g = useTranslations('general');
  const searchParams = useSearchParams();
  const unsubscribeKey = searchParams.get('unsubscribe');
  const [isOpen, setIsOpen] = useState(!!unsubscribeKey);
  const [isLoading, setIsLoading] = useState(!!unsubscribeKey);
  const [message, setMessage] = useState(u('processing'));
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (!unsubscribeKey) return;

    const unsubscribe = async () => {
      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_API_URL}savedSearch/${unsubscribeKey}/unsubscribe`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          }
        );

        const result = await response.json();

        if (response.ok) {
          setIsSuccess(true);
          setMessage(u('success'));
        } else {
          setMessage(result.message || u('error'));
        }
      } catch (error) {
        console.error('Unsubscribe error:', error);
        setMessage(u('error'));
      } finally {
        setIsLoading(false);
      }
    };

    unsubscribe();
  }, [unsubscribeKey]);

  const handleClose = () => {
    // Remove the unsubscribe parameter from the URL without reloading
    const url = new URL(window.location.href);
    url.searchParams.delete('unsubscribe');
    window.history.replaceState({}, '', url);
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <Modal backgroundClose={false} customClose={handleClose}>
      <div className='m-auto md:max-w-[400px]'>
        <h2 className='mb-8 block font-roboto-condensed text-3xl font-bold uppercase text-brand'>
          {isLoading
            ? u('processing')
            : isSuccess
              ? u('title')
              : u('titleError')}
        </h2>
        <p className='mb-6'>{message}</p>

        {!isLoading && (
          <button
            onClick={() => {
              handleClose();
            }}
            className='mb-1 mt-4 w-full appearance-none rounded-sm border border-brand bg-brand p-2 font-bold uppercase text-black transition-all hover:bg-transparent hover:text-white'
          >
            {isSuccess ? g('close') : g('ok')}
          </button>
        )}
      </div>
    </Modal>
  );
}
